import React, { useEffect } from 'react';
import { Typography, Card, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '@/components/Layouts/AdminLayout/AdminLayout';
import { BasicInfo } from '@/pages/admin/components/academy';
import { adminAcademyApi } from '@/services/api';

const { Title, Text } = Typography;

interface AcademyDetail {
  id: string;
  academyName: string;
  representativeName: string;
  representativePhone: string;
  representativeEmail: string;
  businessNumber: string;
  academyCode: string;
  totalUsers: number;
  activeUsers: number;
  teacherCount: number;
  academyUrl: string;
  logo: string;
  registrationStatus: string;
  serviceFeePayment: string;
  serviceFeePaymentDate: any;
  contractStatus: string;
  applicationDate: string;
  registrationDate: string;
}

const AcademyNew: React.FC = () => {
  const navigate = useNavigate();

  // 신규 등록 페이지에서 저장 이벤트를 가로채어 생성 API 호출
  useEffect(() => {
    const onSave = async (e: any) => {
      try {
        const v = e.detail || {};
        const payload = {
          academyName: v.academyName,
          representativeName: v.representativeName,
          representativePhone: v.representativePhone,
          representativeEmail: v.representativeEmail,
          academyUrl: v.academyUrl,
          logoUrl: Array.isArray(v.logo) ? (v.logo[0]?.url || '') : '',
          serviceFeePayment: v.serviceFeePayment,
          serviceFeePaymentDate: v.serviceFeePaymentDate,
          applicationDate: v.applicationDate,
          registrationDate: v.registrationDate,
        };
        const res = await adminAcademyApi.create(payload);
        const data = res?.data || res;
        const code = data?.academyCode || data?.code;
        message.success('학원이 등록되었습니다.');
        if (code) {
          navigate(`/admin/academy/detail/${code}`);
        } else {
          navigate('/admin/academy/list');
        }
      } catch (err: any) {
        message.error(err?.response?.data?.message || '등록 중 오류');
      }
    };
    window.addEventListener('admin:academy:save-basic', onSave as EventListener);
    return () => {
      window.removeEventListener('admin:academy:save-basic', onSave as EventListener);
    };
  }, [navigate]);

  const initialData: AcademyDetail = {
    id: '',
    academyName: '',
    representativeName: '',
    representativePhone: '',
    representativeEmail: '',
    businessNumber: '',
    academyCode: '',
    totalUsers: 0,
    activeUsers: 0,
    teacherCount: 0,
    academyUrl: '',
    logo: '',
    registrationStatus: 'PENDING',
    serviceFeePayment: 'unpaid',
    serviceFeePaymentDate: undefined,
    contractStatus: 'PENDING',
    applicationDate: '',
    registrationDate: '',
  };

  return (
    <AdminLayout>
      <div>
        <div style={{ marginBottom: 24 }}>
          <Title level={2}>학원 등록</Title>
          <Text type="secondary">필요 정보를 입력 후 저장하세요.</Text>
        </div>
        <Card>
          <BasicInfo academyData={initialData} />
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AcademyNew;


